export var Country;
(function (Country) {
    Country["None"] = "None";
    Country["Albania"] = "Albania";
    Country["Andorra"] = "Andorra";
    Country["Austria"] = "Austria";
    Country["Belarus"] = "Belarus";
    Country["Belgium"] = "Belgium";
    Country["BosniaAndHerzegovina"] = "BosniaAndHerzegovina";
    Country["Bulgaria"] = "Bulgaria";
    Country["Croatia"] = "Croatia";
    Country["Cyprus"] = "Cyprus";
    Country["CzechRepublic"] = "CzechRepublic";
    Country["Denmark"] = "Denmark";
    Country["Estonia"] = "Estonia";
    Country["Finland"] = "Finland";
    Country["France"] = "France";
    Country["Germany"] = "Germany";
    Country["Greece"] = "Greece";
    Country["Hungary"] = "Hungary";
    Country["Iceland"] = "Iceland";
    Country["Ireland"] = "Ireland";
    Country["Italy"] = "Italy";
    Country["Latvia"] = "Latvia";
    Country["Lithuania"] = "Lithuania";
    Country["Luxembourg"] = "Luxembourg";
    Country["Malta"] = "Malta";
    Country["Moldova"] = "Moldova";
    Country["Monaco"] = "Monaco";
    Country["Montenegro"] = "Montenegro";
    Country["Netherlands"] = "Netherlands";
    Country["NorthMacedonia"] = "NorthMacedonia";
    Country["Norway"] = "Norway";
    Country["Poland"] = "Poland";
    Country["Portugal"] = "Portugal";
    Country["Romania"] = "Romania";
    Country["Russia"] = "Russia";
    Country["SanMarino"] = "SanMarino";
    Country["Serbia"] = "Serbia";
    Country["Slovakia"] = "Slovakia";
    Country["Slovenia"] = "Slovenia";
    Country["Spain"] = "Spain";
    Country["Sweden"] = "Sweden";
    Country["Switzerland"] = "Switzerland";
    Country["Ukrain"] = "Ukrain";
})(Country || (Country = {}));
export var RuCountryNamesMap = {
    None: 'Нет',
    Albania: 'Албания',
    Andorra: 'Андорра',
    Austria: 'Австрия',
    Belarus: 'Беларусь',
    Belgium: 'Бельгия',
    BosniaAndHerzegovina: 'Босния и Герцеговина',
    Bulgaria: 'Болгария',
    Croatia: 'Хорватия',
    Cyprus: 'Кипр',
    CzechRepublic: 'Чехия',
    Denmark: 'Дания',
    Estonia: 'Эстония',
    Finland: 'Финляндия',
    France: 'Франция',
    Germany: 'Германия',
    Greece: 'Греция',
    Hungary: 'Венгрия',
    Iceland: 'Исландия',
    Ireland: 'Ирландия',
    Italy: 'Италия',
    Latvia: 'Латвия',
    Lithuania: 'Литва',
    Luxembourg: 'Люксембург',
    Malta: 'Мальта',
    Moldova: 'Молдова',
    Monaco: 'Монако',
    Montenegro: 'Черногория',
    Netherlands: 'Нидерланды',
    NorthMacedonia: 'Северная Македония',
    Norway: 'Норвегия',
    Poland: 'Польша',
    Portugal: 'Португалия',
    Romania: 'Румыния',
    Russia: 'Россия',
    SanMarino: 'Сан-Марино',
    Serbia: 'Сербия',
    Slovakia: 'Словакия',
    Slovenia: 'Словения',
    Spain: 'Испания',
    Sweden: 'Швеция',
    Switzerland: 'Швейцария',
    Ukrain: 'Украина',
};
export var RuCountryNamesSelectValues = [
    { label: 'Нет', value: Country.None },
    { label: 'Албания', value: Country.Albania },
    { label: 'Андорра', value: Country.Andorra },
    { label: 'Австрия', value: Country.Austria },
    { label: 'Беларусь', value: Country.Belarus },
    { label: 'Бельгия', value: Country.Belgium },
    { label: 'Босния и Герцеговина', value: Country.BosniaAndHerzegovina },
    { label: 'Болгария', value: Country.Bulgaria },
    { label: 'Хорватия', value: Country.Croatia },
    { label: 'Кипр', value: Country.Cyprus },
    { label: 'Чехия', value: Country.CzechRepublic },
    { label: 'Дания', value: Country.Denmark },
    { label: 'Эстония', value: Country.Estonia },
    { label: 'Финляндия', value: Country.Finland },
    { label: 'Франция', value: Country.France },
    { label: 'Германия', value: Country.Germany },
    { label: 'Греция', value: Country.Greece },
    { label: 'Венгрия', value: Country.Hungary },
    { label: 'Исландия', value: Country.Iceland },
    { label: 'Ирландия', value: Country.Ireland },
    { label: 'Италия', value: Country.Italy },
    { label: 'Латвия', value: Country.Latvia },
    { label: 'Литва', value: Country.Lithuania },
    { label: 'Люксембург', value: Country.Luxembourg },
    { label: 'Мальта', value: Country.Malta },
    { label: 'Молдова', value: Country.Moldova },
    { label: 'Монако', value: Country.Monaco },
    { label: 'Черногория', value: Country.Montenegro },
    { label: 'Нидерланды', value: Country.Netherlands },
    { label: 'Северная Македония', value: Country.NorthMacedonia },
    { label: 'Норвегия', value: Country.Norway },
    { label: 'Польша', value: Country.Poland },
    { label: 'Португалия', value: Country.Portugal },
    { label: 'Румыния', value: Country.Romania },
    { label: 'Россия', value: Country.Russia },
    { label: 'Сан-Марино', value: Country.SanMarino },
    { label: 'Сербия', value: Country.Serbia },
    { label: 'Словакия', value: Country.Slovakia },
    { label: 'Словения', value: Country.Slovenia },
    { label: 'Испания', value: Country.Spain },
    { label: 'Швеция', value: Country.Sweden },
    { label: 'Швейцария', value: Country.Switzerland },
    { label: 'Украина', value: Country.Ukrain },
];
